/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extracting_FramesInputs */



/**
* | output |
* | --- |
* | "Extracting frames (1fps)..." |
*
* @param {Extracting_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const extracting_frames = /** @type {((inputs?: Extracting_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extracting_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction des images (1 image/s)...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzelbilder werden extrahiert (1 Bild pro Sekunde)...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione dei fotogrammi (1 fps)...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение кадров (1 кадр в секунду)...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extrayendo fotogramas (1 fps)...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提取帧（1fps）...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームを抽出中（1fps）...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम निकाले जा रहे हैं (1fps)...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extraindo frames (1fps)...")
	return /** @type {LocalizedString} */ ("Extracting frames (1fps)...")
});